<template>
  <div class="municipal-operation">
    <MunicipalEcoTimeseries :codes="code ? [code] : []" @open-source="openSource" />
    <CDialog
      id="municipal-source-trace"
      ref="sourceDialog"
      DIALOGHEIGHT="75vh"
      :dialogVisible="dialogVisible">
      <el-dialog
        :title="`单指标财报追源 · ${source.indicator || ''}`"
        :visible.sync="dialogVisible"
        width="82vw"
        top="3vh"
        @closed="clearSourceTrace">
        <div class="source-trace-meta">
          <span>{{ source.code }}</span>
          <span>{{ source.period }}</span>
          <span>{{ source.indicator }}</span>
          <span>{{ source.category }}</span>
        </div>
        <div v-loading="loading" v-html="iframeContent" class="source-trace-frame"></div>
      </el-dialog>
    </CDialog>
  </div>
</template>

<script>
import CDialog from '@/components/Basic/CDialog';
import MunicipalEcoTimeseries from '@/components/UnderlyingAssets/MunicipalEcoTimeseries.vue';

export default {
  name: 'IndividualMunicipalEcoOperation',
  components: { CDialog, MunicipalEcoTimeseries },
  props: { code: { type: String, default: '' } },
  data() {
    return {
      dialogVisible: false,
      iframeContent: '',
      blobUrl: '',
      loading: false,
      requestLocked: false,
      source: { code: '', period: '', indicator: '', category: '市政生态' },
    };
  },
  beforeDestroy() {
    this.clearSourceBlob();
  },
  methods: {
    openSource({ code, period, indicator }) {
      this.showIframe(code, period, indicator);
    },
    async showIframe(code, rpPeriod, indicator) {
      if (this.requestLocked || !code || !rpPeriod || !indicator) return;
      this.requestLocked = true;
      this.loading = true;
      this.dialogVisible = true;
      this.source = { code, period: rpPeriod, indicator, category: '市政生态' };
      const query = new URLSearchParams({ code, rp_period: rpPeriod, html_variant: 'original' });
      query.append('indicators', indicator);
      try {
        const { data } = await this.$https.get(`/api/v4/single_operation_html?${query}`);
        if (data.code !== 200) {
          this.dialogVisible = false;
          return this.$message.error(data.msg);
        }
        const result = data.data || {};
        if (!result.display_html) {
          this.dialogVisible = false;
          return this.$message.warning('当前指标暂无可展示的财报追源原文');
        }
        this.source.category = result.category || '市政生态';
        this.clearSourceBlob();
        this.blobUrl = URL.createObjectURL(new Blob([result.display_html], { type: 'text/html' }));
        this.iframeContent = `<iframe src="${this.blobUrl}" style="width:100%;height:100%;border:0" tabindex="0"></iframe>`;
      } catch (error) {
        this.dialogVisible = false;
        this.$message.error('财报原文加载失败');
      } finally {
        this.loading = false;
        this.requestLocked = false;
      }
    },
    clearSourceBlob() {
      if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
      this.blobUrl = '';
    },
    clearSourceTrace() {
      this.clearSourceBlob();
      this.iframeContent = '';
    },
  },
};
</script>

<style scoped lang="less">
.municipal-operation { width: 100%; }
.source-trace-meta {
  display: flex;
  gap: 18px;
  padding: 0 2px 10px;
  color: var(--table_color);
  font-size: 13px;
}
.source-trace-frame {
  width: 100%;
  height: 78vh;
  overflow: hidden;
  border: 1px solid var(--table_brc);
  border-radius: 6px;
}
</style>
